import WebGL2Component from '@/components/core/WebGLComponent';

export default function TopographicalMap() {
  return (
    <div className="fixed inset-0 -z-10 size-full bg-theme-white">
      <WebGL2Component
        overlay={`/assets/topographical-map-4.png`}
        video={null}
        image={null}
      />
    </div>
  );
}
